
import { MailSettings, EmailMethod } from "@/models/mail-settings";
import Vue from "vue";
import MailAutoConfig from "@/components/settings-default/MailAutoConfig.vue";
import { MailConfig } from "@/utils/mail-config";
import { MailSettingsService } from "@/services/mail-settings-service";

export default Vue.extend({
	data() {
		return {
			testDialog: false,
			password: "",
			sending: false,
			emailServer: "",
			emailServerPort: 465,
			useSsl: false,
			showPassword: false,
			startAutoConfig: false,
			insecureSkipVerify: false,
			gmailAddress: "",
			microsoftAddress: ""
		};
	},
	props: {
		mailSettings: {
			type: Object as () => MailSettings,
			required: true
		}
	},
	computed: {
		serverWarning():{ toString():string } | string {
			if (!this.mailSettings) return "";
			if (!this.mailSettings.EmailServer) return "";
			if (this.mailSettings.EmailServer == "") return "";
			if (this.mailSettings.EmailServer.trim() == "smtp.gmail.com:587") {
				return this.$ct("warning-use-connect-with-google");
			}
			return "";
		},
		loggedInWithGoogle():boolean {
			return this.mailSettings.EmailMethod == EmailMethod.GMAIL;
		},
		loggedInWithMicrosoft():boolean{
			return this.mailSettings.EmailMethod == EmailMethod.MICROSOFT;
		},
		showActions():boolean{
			return !this.loggedInWithGoogle && !this.loggedInWithMicrosoft;
		},
		emailServerUrl():string{
			if (this.emailServer == "") {
				return "";
			}
			return `${this.emailServer}:${this.emailServerPort}`;
		}
	},
	watch: {
		useSsl(){
			if (this.useSsl){
				this.emailServerPort = 587;
			}else{
				this.emailServerPort = 465;
			}
		},
		loggedInWithGoogle: {
			immediate: true,
			handler(){
				if (!this.loggedInWithGoogle) {
					this.gmailAddress = "";
					return;
				}
				this.fetchGoogleEmail();
			}
		},
		loggedInWithMicrosoft: {
			immediate: true,
			handler(){
				if (!this.loggedInWithMicrosoft) {
					this.microsoftAddress = "";
					return;
				}
				this.fetchMicrosoftAddress();
			}
		}
	},
	methods: {
		async saveAutoConfig(event: MailConfig) {
			this.mailSettings.Email = event.UserName;
			this.emailServer = event.Host;
			this.emailServerPort = event.Port;
			this.password = event.Password;
			this.useSsl = !!event.Encryption;
			this.testDialog = true;
		},
		async save(test: boolean) {
			if (this.sending) return;
			if (!this.mailSettings) return;
			this.mailSettings.EmailServer = this.emailServerUrl;
			this.mailSettings.InsecureSkipVerify = this.insecureSkipVerify;
			if (!this.password.match(/^\s*$/)) {
				this.mailSettings.EmailPassword = this.password;
			}
			try {
				this.sending = true;
				let settings = await MailSettingsService.updateSettings(this.mailSettings, test);
				this.$emit("saved", settings);
				this.$wf.notify(this.$t("common.success").toString(), "success", 3000, "check");
			} catch (err) {
				if(test){
					await this.$wf.dialog(this.$ct("testEmailFailed"), this.$ct("common.ok"), this.$ct("common.warning"), "warning");
				}
			}
			this.testDialog = false;
			this.sending = false;
		},
		async gmailLogin() {
			if (!this.mailSettings) return;
			await MailSettingsService.gmailLogin(this.mailSettings);
			this.mailSettings.EmailMethod = EmailMethod.GMAIL;
			await this.save(false);
		},
		async gmailLogout() {
			if (!this.mailSettings) return;
			await MailSettingsService.gmailLogout(this.mailSettings);
			this.mailSettings.EmailMethod = EmailMethod.DEFAULT;
			await this.save(false);
		},

		async microsoftLogin():Promise<void> {
			if (!this.mailSettings) return;
			await MailSettingsService.microsoftLogin(this.mailSettings);
			this.mailSettings.EmailMethod = EmailMethod.MICROSOFT;
			await this.save(false);
		},
		async microsoftLogout():Promise<void> {
			if (!this.mailSettings) return;
			await MailSettingsService.microsoftLogout(this.mailSettings);
			this.mailSettings.EmailMethod = EmailMethod.DEFAULT;
			await this.save(false);
		},
		async fetchGoogleEmail(){
			this.gmailAddress = await MailSettingsService.getGoogleEmail(this.mailSettings);
		},
		async fetchMicrosoftAddress(){
			this.microsoftAddress = await MailSettingsService.getMicrosoftEmail(this.mailSettings);
		}
	},
	created(){
		let str = this.mailSettings.EmailServer.split(":");
		this.emailServer = str[0] || "";
		this.emailServerPort = parseInt(str[1] || "465");
		if (this.emailServerPort == 587){
			this.useSsl = true;
		}
		this.insecureSkipVerify = this.mailSettings.InsecureSkipVerify;
	},
	components: {
		MailAutoConfig
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	},
});
